import { Link } from 'react-router-dom';

const ProjectCard = ({ project }) => {
  return (
    <Link to={project.link} style={{ textDecoration: 'none' }}>
      <div className="project-card">
        <div className="project-number">{project.number}</div>
        <div className="project-header">
          <h3 className="project-title">{project.title}</h3>
          <div className="project-result">{project.result}</div>
        </div>
        <div className="project-body">
          <p className="project-description">{project.description}</p>
          <div className="project-stats-grid">
            {project.stats.map((stat, index) => (
              <div className="stat-box" key={index}>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
          <div className="project-tags">
            {project.tags.map((tag, index) => (
              <span className="tag" key={index}>{tag}</span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProjectCard;